import React, { useState,useEffect } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FaMapMarkerAlt, FaCalendarAlt} from 'react-icons/fa'; // icons
import './css/ticket.css'; 
import { API_URL_BASE } from './config';

function PrivatePurchase() {
	const { eventid } = useParams();
	const [eventresult, setEventResult] = useState(null);
	const [loading, setLoading] = useState(true);
	const [quantities, setQuantities] = useState({});
	const [grandTotal, setGrandTotal] = useState(0);
	const [ticketsToPurchase, setTicketToPurchase] = useState([]);
	const [processingfee, setProcessingfee] = useState(0);
	const [ticketNotification, setTicketNotification] = useState(false);
	const navigate = useNavigate();
	const { t, i18n } = useTranslation();
	let processingfee_fixed = 25;
	
	// Trim spaces + remove quotes
	 const eventidparam = eventid?.trim().replace(/["'\W_]+$/g, "");
	
	const languages = [
	  { code: "nl", label: "NL", flag: "🇳🇱" },
	  { code: "en", label: "EN", flag: "🇬🇧" }
	];

	
	useEffect(() => {
	  fetch(API_URL_BASE + '/ticket.json',{
		method: 'POST',
		     headers: {
		       'Content-Type': 'application/json',
		     },
		     body: JSON.stringify({
				fetchEventDetailForPurchase: {
					eventId: eventidparam
		        }
		     }),
		   })
	    .then(res => {
	      if (!res.ok) throw new Error('Event not found');
	      return res.json();
	    })
	    .then(data => {
	        setEventResult(data.eventdetails); // Adjust based on your actual response shape
	    })
	    .catch(err => {
	      console.error('Error loading event:', err);
	      setEventResult(null);
	    })
	    .finally(() => setLoading(false));
	}, [eventidparam]);
	
	
	useEffect(() => {
		
		console.log(eventresult);
		if (!eventresult?.tickets) return;
		
		let processingfee_fixed = 25;
		
		if(eventresult?.event?.type === "PRIVATE") {
		  processingfee_fixed = 25;
		}
		console.log("gert result");
		// Calculate subtotal and processing fee together
		const result = eventresult.tickets.reduce(
		  (acc, ticket) => {
		    const quantity = quantities[ticket.ticketid] || 1;

		    acc.subtotal += quantity * ticket.price ;

		    return acc;
		  },
		  { subtotal: 0, processingfee: 0 }
		);
		console.log("result");
		console.log(result);

		const total = result.subtotal + processingfee_fixed;

		  setProcessingfee(processingfee_fixed);
		  setGrandTotal(total);

		  const ticketsToPurchase = eventresult.tickets
		     .filter(ticket => (quantities[ticket.ticketid] || 1) > 0)
		     .map(ticket => ({
		       ticketid: ticket.ticketid,
		       ticketsku: ticket.sku,
		       ticketsold: quantities[ticket.ticketid]
		     }));

		   setTicketToPurchase(ticketsToPurchase);  
	  
	}, [eventresult]);
	
	
	//Check for the past events
	const eventEnded =
	  eventresult?.event?.enddatetime &&
	  Date.now() > eventresult.event.enddatetime;
	  
	useEffect(() => {
	  if (!ticketNotification ) {
	    setTicketNotification(true);
	  }
	}, [ticketNotification]);


	const handleCountChange = (ticketId, value) => {
	  const newQuantity = Math.max(0, Math.min(10, Number(value)));
	  setQuantities((prev) => ({
	    ...prev,
	    [ticketId]: newQuantity
	  }));
	};
	
	const handleSubmit = () => {
		navigate(`/pay/privatecheckout/${eventidparam}`,		{
		    state: {
		      event: eventresult?.event,
		      tickets: ticketsToPurchase,
		      total: grandTotal,
		      processingfee,
			  }
		    });
	};
	


  return (
	<div>
	<div className="ticket-purchase">
    <div className="ticket-container">
	{!loading && eventresult ? (
		<>	
		<div className="event-header">
		  <div className="event-text">	
			  <h1>{eventresult.event.name}</h1>
			  <p className="event-description">{eventresult.event.description}</p>
		  </div>
		  <div className="purchase-event-image">
		    <img
		      src={`data:image/png;base64,${eventresult.event.image}`}
		      alt=""
		    />
		  </div>		  
		</div>
		

		{eventEnded ? (
		<div className="event-notification blink">
			<p> Sorry this payment link is closed  !!! </p>
		</div>
		) : null }

		<div className="tickets-list">
		{eventresult.tickets.map((ticket) => {
			const quantity = quantities[ticket.ticketid] || 0;
			const total = ticket.price/100 * quantity;
			
		
			return (
					<div key={ticket.ticketid} className="ticket-card">
					       <div className="ticket-info">
							   <div className="ticket-name-price">
							     <div className="ticket-name">{ticket.name}</div>
							     <div className="ticket-price">€{(ticket.price / 100).toFixed(2)}</div>
							   </div>
								{(ticket.capacity - ticket.ticketsold !== 0) ? (
									<>
						            <div className="ticket-quantity">
										<select
										  value={quantity}
										  onChange={(e) => handleCountChange(ticket.ticketid, e.target.value)}
										  disabled={true}
										>
										    <option key={1} value={1}>
										      {1}
										    </option>
										  
										</select>
									</div>
									<div className="ticket-total">€{(ticket.price/100) .toFixed(2)}</div>
								
									</>
									) : <div className="ticket-notification-sold"><p>SOLD OUT</p> </div>}
							</div>
					     </div>
		)})}
		</div>
		
		
		{/* Summary Section */}
		<div className="summary-section">
		  {<div className="processing-fee">
		    <strong>{t("processingFee")}:</strong> €{(processingfee/100).toFixed(2) || '0.00'}
		  </div>}

		  <div className="grand-total">
		    <strong>{t("total")}:</strong> €{(grandTotal / 100).toFixed(2)}
		  </div>
		</div>
		
		<div className="ticket-form">
		  <button type="submit"  
		  	disabled={ticketsToPurchase.length === 0 || (eventresult?.event?.type !== "FREE" && grandTotal <= 0) || eventEnded} 
			onClick={handleSubmit}>{t("confirm")}</button>
		</div>
	
	</>
	

	) : null}

	</div>	

    </div>
	
		
	<div className="ticketpurchase-footer">	
		<div className="footer">
		<span >© Processed by Buydeal.EU B.V</span>
		</div>
	
		<div className="lang-dropdown">
		  <select
		    value={i18n.language}
		    onChange={(e) => i18n.changeLanguage(e.target.value)}
		  >
		    {languages.map((lng) => (
		      <option key={lng.code} value={lng.code}>
		        {lng.flag} {lng.label}
		      </option>
		    ))}
		  </select>
		</div>
	</div>	
	</div> //main div

  );
}

export default PrivatePurchase;